import { render, staticRenderFns } from "./me.vue?vue&type=template&id=5f8abe58&"
import script from "./me.vue?vue&type=script&lang=js&"
export * from "./me.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8abe58')) {
      api.createRecord('5f8abe58', component.options)
    } else {
      api.reload('5f8abe58', component.options)
    }
    module.hot.accept("./me.vue?vue&type=template&id=5f8abe58&", function () {
      api.rerender('5f8abe58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/me.vue"
export default component.exports